export enum EWorkflowViewFilter {
	ALL = 'all',
	TEXT_BOOKING = 'text-booking',
	BOOKING_REQUEST = 'booking-request',
}
